import { render, staticRenderFns } from "./unloadDetail.vue?vue&type=template&id=d933ca40&"
import script from "./unloadDetail.vue?vue&type=script&lang=js&"
export * from "./unloadDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports